<template>
	<el-dialog :modal="false" :visible.sync="visible" title="绑定手机号" width="400px" :close-on-click-modal="false"
		:close-on-press-escape="false" :show-close="false">
		<div class="bind-phone-dialog">
			<!-- 微信用户信息 -->
			<div class="wechat-info" v-if="wechatInfo">
				<el-avatar :size="60" :src="wechatInfo.avatar || ''" />
				<div class="user-info">
					<div class="nickname">{{ wechatInfo.nickname || '微信用户' }}</div>
					<div class="tip">首次使用需要绑定手机号</div>
				</div>
			</div>

			<!-- 表单 -->
			<el-form ref="form" :model="form" :rules="rules" class="bind-form">
				<el-form-item prop="phone">
					<el-input v-model="form.phone" placeholder="请输入手机号码" prefix-icon="el-icon-mobile-phone"
						maxlength="11" clearable />
				</el-form-item>

				<el-form-item prop="code" class="code-item">
					<el-input v-model="form.code" placeholder="请输入验证码" prefix-icon="el-icon-message" maxlength="6"
						clearable class="code-input">
						<template slot="append">
							<el-button type="primary" :disabled="countdown > 0 || gettingCode" @click="getCode"
								class="code-btn">
								{{ countdownText }}
							</el-button>
						</template>
					</el-input>
				</el-form-item>
			</el-form>

			<!-- 固定验证码提示 -->
			<div class="fixed-code-tip">
				<i class="el-icon-info"></i>
				<span>提示：如绑定的手机号存在账号，邀请码填写后不会绑定新的上级</span>
			</div>

			<!-- 按钮 -->
			<div class="dialog-footer">
				<el-button type="primary" :loading="binding" @click="handleBind" class="bind-btn">
					绑定并登录
				</el-button>
				<el-button @click="handleCancel" :disabled="binding">
					取消
				</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name: 'BindPhoneDialog',
		props: {
			wechat_info: {
				type: Object,
				default: () => ({})
			}
		},
		data() {
			// 手机号验证规则
			const validatePhone = (rule, value, callback) => {
				if (!value) {
					callback(new Error('手机号不能为空'));
				} else if (!/^1[3-9]\d{9}$/.test(value)) {
					callback(new Error('请输入正确的手机号码'));
				} else {
					callback();
				}
			};

			// 验证码验证规则
			const validateCode = (rule, value, callback) => {
				if (!value) {
					callback(new Error('验证码不能为空'));
				} else {
					callback();
				}
			};

			return {
				visible: true,
				binding: false,
				gettingCode: false,
				countdown: 0,
				countdownTimer: null,
				form: {
					phone: '',
					code: ''
				},
				rules: {
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					code: [{
						required: true,
						validator: validateCode,
						trigger: 'blur'
					}]
				},
				wechatInfo: {},
			};
		},
		computed: {
			countdownText() {
				if (this.gettingCode) {
					return '发送中...';
				}
				if (this.countdown > 0) {
					return `${this.countdown}s后重新获取`;
				}
				return '获取验证码';
			}
		},
		mounted() {
			this.wechatInfo = this.wechat_info;
			this.$vuex('wechat_info', {}, true);
		},
		methods: {
			// 打开弹窗
			open() {
				this.visible = true;
				// 重置表单
				this.resetForm();
			},

			// 关闭弹窗
			close() {
				this.visible = false;
				this.resetForm();
			},

			// 重置表单
			resetForm() {
				this.form.phone = '';
				this.form.code = '';
				this.binding = false;
				this.gettingCode = false;
				this.clearCountdown();

				if (this.$refs.form) {
					this.$refs.form.clearValidate();
				}
			},

			// 清除倒计时
			clearCountdown() {
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}
				this.countdown = 0;
			},

			// 获取验证码
			async getCode() {
				// 先验证手机号
				try {
					await this.$refs.form.validateField('phone');
				} catch (error) {
					return;
				}

				this.gettingCode = true;

				this.$post('sendAliyunSms', {
					phone: this.form.phone,
				}).then(res => {
					this.$message.success('验证码已发送');
					this.countdown = 60;
					this.countdownTimer = setInterval(() => {
						this.countdown--;
						if (this.countdown <= 0) {
							this.clearCountdown();
						}
					}, 1000);
					this.gettingCode = false;
				}).catch(err => {
					this.gettingCode = false;
					this.$message.error(err);
				});
			},

			// 处理绑定
			async handleBind() {
				try {
					// 验证表单
					await this.$refs.form.validate();

					this.binding = true;

					// 调用绑定接口
					const bindData = {
						phone: this.form.phone,
						code: this.form.code,
						openid: this.wechatInfo.openid || '',
						unionid: this.wechatInfo.unionid || '',
						nickname: this.wechatInfo.nickname || '微信用户',
						avatar: this.wechatInfo.avatar || ''
					};

					const res = await this.$post('wechatRegister', bindData);

					if (res.extra && res.extra.UserCheck) {
						// 绑定成功
						this.handleBindSuccess(res);
					} else {
						this.$message.error('绑定失败，请重试');
					}
				} catch (error) {
					if (error !== 'validate') {
						this.$message.error('绑定失败: ' + (error.message || '网络错误'));
					}
				} finally {
					this.binding = false;
				}
			},

			// 处理绑定成功
			handleBindSuccess(res) {
				// 保存登录信息
				try {
					if (this.$apimit && res.extra.UserCheck) {
						this.$apimit.set(res.extra.UserCheck);
					}

					if (this.$vuex) {
						if (res.data) {
							this.$vuex('UserInfo', res.data, true);
						}
						if (res.extra.UserCheck) {
							this.$vuex('UserCheck', res.extra.UserCheck, true);
						}
						// 清除微信信息缓存
						this.$vuex('wechat_info', {}, true);
					}

					// 保存到localStorage
					if (res.extra.UserCheck) {
						localStorage.setItem('UserCheck', JSON.stringify(res.extra.UserCheck));
					}
					if (res.data) {
						localStorage.setItem('UserInfo', JSON.stringify(res.data));
					}

					// 清理微信信息缓存
					localStorage.removeItem('wechat_info');

				} catch (e) {
					this.$message.error('保存登录信息失败');
				}

				// 关闭弹窗
				this.close();

				// 通知父组件
				this.$emit('bind-success', res.data);
			},

			// 处理取消
			handleCancel() {
				this.$confirm('确定要取消绑定吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 清除微信信息缓存
					if (this.$vuex) {
						this.$vuex('wechat_info', {}, true);
					}
					localStorage.removeItem('wechat_info');

					this.close();
					this.$emit('bind-cancel');
				}).catch(() => {});
			}
		},
		watch: {
			visible(val) {
				if (!val) {
					this.resetForm();
				}
			}
		},
		beforeDestroy() {
			this.clearCountdown();
		}
	};
</script>

<style scoped>
	.bind-phone-dialog {
		padding: 10px 0;
	}

	.wechat-info {
		display: flex;
		align-items: center;
		gap: 15px;
		margin-bottom: 25px;
		padding: 15px;
		background: #f8f9fa;
		border-radius: 8px;
	}

	.wechat-info .user-info {
		flex: 1;
	}

	.wechat-info .nickname {
		font-size: 16px;
		font-weight: 500;
		color: #333;
		margin-bottom: 5px;
	}

	.wechat-info .tip {
		font-size: 13px;
		color: #666;
	}

	.bind-form {
		margin-bottom: 20px;
	}

	.bind-form .code-item {
		margin-bottom: 10px;
	}

	.bind-form .code-input>>>.el-input-group__append {
		padding: 0;
		background: transparent;
		border: none;
	}

	.bind-form .code-btn {
		padding: 11px 15px;
		margin-left: 1px;
	}

	.fixed-code-tip {
		padding: 10px 15px;
		margin-bottom: 20px;
		background: #f0f9ff;
		border: 1px solid #b3d8ff;
		border-radius: 4px;
		font-size: 13px;
		color: #409eff;
	}

	.fixed-code-tip i {
		margin-right: 8px;
	}

	.fixed-code-tip strong {
		color: #e6a23c;
		font-weight: 600;
	}

	.dialog-footer {
		display: flex;
		justify-content: center;
		gap: 15px;
	}

	.dialog-footer .bind-btn {
		min-width: 120px;
	}
</style>